import { configureStore } from '@reduxjs/toolkit'
import conventionsSlice from './slices/conventionsSlice'
import launchParamsSlice from './slices/launchParamsSlice'
import sessionSlice from './slices/sessionSlice'
import walletSlice from './slices/walletSlice'
import configurationsSlice from './slices/configurationsSlice'
import uiSlice from './slices/uiSlice'
import socketSlice from './slices/socketSlice'
import eventsSlice from './slices/eventsSlice'
import layoutSlice from './slices/layoutSlice'
import bettingSlice from './slices/bettingSlice'

const store = configureStore({
  reducer: {
    launchParams: launchParamsSlice,
    session: sessionSlice,
    conventions: conventionsSlice,
    wallet: walletSlice,
    configurations: configurationsSlice,
    ui: uiSlice,
    socket: socketSlice,
    events: eventsSlice,
    layout: layoutSlice,
    betting: bettingSlice,
  },
})

export default store
